(function ($) {
    "use strict";

    $(function () {


        /* HERO SLIDER */


    });

})(jQuery);